// import RulePack from './RulePack';

export default {
  priority: 3,
  path: "packet",
  permissions: ["TimeAttendanceMenu/SmsMenu/SmsDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./Definition")
  ),
  name: app.translate("routes.home.requests.Definition"),
  icon: "content-paste",
  drawer: true,
  description: `فیش حقوقی: امکان مشاهده فایل PDF فیش حقوقی در این منو وجود دارد. پس از انجام محاسبات حقوق و ایجاد آنها در قالب مشخصی که به نام گذاری فایل‌ها مربوط می شود و قراردادن آنها در محل مورد نظر در سرور نرم افزار،‌ هر پرسنل می تواند به فایل فیش حقوقی ماه و سال مورد نظر خود دسترسی داشته باشد. 
این موضوع می تواند مراجعات به واحد مالی را کاهش داده، همچنین از هزینه های مربوط به چاپ فیش حقوقی نیز بکاهد.`,
};
